export default __webpack_public_path__ + "static/media/skillset.7ee53b19.png";